'use client';

import { Toaster } from 'react-hot-toast';

/** `recommend.client` 등 학원 플로우와 동일한 토스트 스타일 */
const toastOptions = {
  duration: 2000 as const,
  style: {
    background: '#363636',
    color: '#fff',
    borderRadius: '100px',
  },
};

export default function CommunityToaster() {
  return <Toaster position="bottom-center" toastOptions={toastOptions} />;
}
